import React from "react";
import { Box, Grid } from "@mui/material";

import { PageContainer } from "../common";
import WelcomeCard from "../dashboards/WelcomeCard";
import TodoCount from "../dashboards/TodoCount";
import ShareCompanyCount from "../dashboards/ShareCompanyCount";
import Complete from "../dashboards/Complete";
import CompanyCount from "../dashboards/CompanyCount";
import ProgressCompanyCount from "../dashboards/ProgressCompanyCount";
import Signuppath from "../dashboards/Signuppath";
import MonthCompany from "../dashboards/MonthCompany";
import NoticeList from "../dashboards/NoticeList";
import NewList from "../dashboards/NewList";

const MainThree = () => {
  return (
    <PageContainer>
      <Box mt={3}>
        <Grid container spacing={3}>
          {/* 배너부분 */}
          <Grid item xs={12} lg={8}>
            <WelcomeCard />
          </Grid>

          {/* column */}
          <Grid item xs={12} lg={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                {/* 업무카드 할일 */}
                <TodoCount />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* 업무카드 진행중 */}
                <ProgressCompanyCount />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            {/* 가입경로  */}
            <Signuppath />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            {/* 월별 기업등록 */}
            <MonthCompany />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                {/* 담당자기업 건수 */}
                <CompanyCount />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* 공유된 기업 건수 */}
                <ShareCompanyCount />
              </Grid>
              <Grid item xs={12}>
                {/* 기업 완료률 */}
                <Complete />
              </Grid>
            </Grid>
          </Grid>
          {/* 공지사항 */}
          <Grid item xs={12} lg={6}>
            <NoticeList />
          </Grid>
          {/* 이벤트 뉴스 */}
          <Grid item xs={12} lg={6}>
            <NewList />
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default MainThree;
